import colors from '_containers/Theme/intheblack/colors';

export default {
  action: colors.all.brandPrimary1,
  attributeIcon: colors.all.neutral700,
  background: 'transparent',
  cardBackground: colors.all.neutralWhite,
  border: `1px solid ${colors.all.neutral200}`,
  borderDashed: `0px dashed ${colors.all.neutral200}`,
  borderDashedHover: `0px dashed ${colors.all.neutral800}`,
  borderFocus: `2px solid ${colors.all.interactive200}`,
  borderHover: 'none',
  borderRadius: 4,
  borderSelected: 'none',
  boxShadow: null,
  boxShadowHover: null,
  ctaColor: 'tertiary',
  highlightColour: {
    campaign: colors.all.brandPrimary1,
    category: colors.all.brandPrimary1,
    contentDetail: colors.all.brandPrimary1,
    inPractice: colors.all.brandSecondary2,
    inTheBlack: colors.all.brandSecondary3,
    podcast: colors.all.brandPrimary2,
    textOnly: colors.all.brandPrimary1,
  }
};

export const darkMode = {
  background: colors.all.brandPrimary3,
  headingColor: colors.all.neutralWhite,
  color: colors.all.neutralWhite,
  ctaColor: 'tertiaryDark',
};
